import { StrictMode, type ReactNode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { applyManaCursors } from "./lib/applyManaCursors";
import {
  isInformationRoute,
  pathnameToOverlayRoute,
} from "./lib/overlayRoutes";
import { resolvePublicPath } from "./seo/resolvePublicPath";
import "./index.css";

applyManaCursors();

const rootElementOrNull = document.getElementById("root");
if (!rootElementOrNull) {
  throw new Error("Root element not found");
}
const rootElement: HTMLElement = rootElementOrNull;

const initialRoute = pathnameToOverlayRoute(window.location.pathname);
const resolvedPath = resolvePublicPath(window.location.pathname);

async function renderApplication() {
  if (resolvedPath.type === "not-found") {
    const { default: NotFoundPage } = await import("./seo/NotFoundPage");
    mountRoot(
      <StrictMode>
        <NotFoundPage />
      </StrictMode>,
    );
    return;
  }

  if (isInformationRoute(initialRoute)) {
    const { default: InformationApp } = await import("./InformationApp");

    mountRoot(
      <StrictMode>
        <InformationApp route={initialRoute} />
      </StrictMode>,
    );
    return;
  }

  const { default: App } = await import("./App");

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

function mountRoot(node: ReactNode) {
  if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, node);
    return;
  }

  createRoot(rootElement).render(node);
}

void renderApplication();
